import script from "./HeaderLang.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderLang.vue?vue&type=script&setup=true&lang=js"

import "./HeaderLang.vue?vue&type=style&index=0&id=38768e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38768e56"]])

export default __exports__